<template>
    <div class="pack-box gift-choice gift-choice__tableau ">
        <div class="pack-title">

            <img src="/images/fr_new_home/cadeau.svg" alt="cadeaux"/>
            <h3>
                Kies je <span class="orange-text"> geschenk</span>
            </h3>
        </div>
        <h6 class="text-uppercase orange-text">Krijg toegang tot een uitgebreide catalogus met geschenken</h6>
        <p>
            Consumeren gaat gepaard met keuzevrijheid. Testaankoop laat je daarom zelf je geschenk kiezen uit een
            uitgebreide catalogus.
        </p>
        <div class="tableau">
            <div class="tableau-title-container">
                <p class="tableau-title">Een paar voorbeelden van cadeau’s </p>
<!--                <p class="product-offre tableau-title">Aanbod</p>-->
                <p class="product-price tableau-title">Prijs</p>
            </div>
            <div class="product-row" v-for="(elem,index) in tableau">
                <p class="product-name" >{{ elem }}</p>
<!--                <p class="product-offre">€2/2 maanden</p>-->
                <p class="product-price">GRATIS</p>
            </div>

            <p class="asterix">*Persoonlijke bijdrage vereist. Voor betaling is creditcard vereist. </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "GiftChoiceTableau",
    data() {
        return {
            tableau: [
                'Mixer 5000 - Philips',
                'Koffiemachine',
                'Aifryer',
                'Mini blender - HKoenig',
                'Citruspers - HKoenig',
                'Stoomkoker - HKoenig',
                'Wafelijzer & tosti - Livoo',
            ],
        }
    },

}
</script>

<style scoped>

</style>
